/** Formatação monetária da página pública. */
export const formatarMoeda = (valor?: number | null) =>
  (Number(valor) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const formatarPercentual = (valor?: number | null) =>
  `${(Number(valor) || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;

/** Parcelamentos simulados no resumo, além do à vista — como no wizard interno. */
export const PARCELAS = Array.from({ length: 11 }, (_, indice) => indice + 2); // 2x .. 12x

export const valorDaParcela = (valorTotal: number, parcelas: number): number => {
  if (!valorTotal || parcelas <= 0) return 0;
  return Number((valorTotal / parcelas).toFixed(2));
};

/** Máscara de celular no formato (99) 99999-9999. */
export const mascararCelular = (valor: string): string => {
  const digitos = valor.replace(/\D/g, "").slice(0, 11);
  if (digitos.length > 6) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
  }
  if (digitos.length > 2) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
  }
  return digitos;
};
